export default __webpack_public_path__ + "static/media/Icon-Sick.b37b4795.svg";